import { render, staticRenderFns } from "./exception-page.vue?vue&type=template&id=36c5e342&scoped=true&"
import script from "./exception-page.vue?vue&type=script&lang=js&"
export * from "./exception-page.vue?vue&type=script&lang=js&"
import style0 from "./exception-page.vue?vue&type=style&index=0&id=36c5e342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5e342",
  null
  
)

export default component.exports